import { render } from "./MyPatients.vue?vue&type=template&id=8301b39a&ts=true"
import script from "./MyPatients.vue?vue&type=script&lang=ts"
export * from "./MyPatients.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__